import { TableWithPagination } from "shared/Components/tableWithPagination/index.js";
import { plus } from "helper/icons";
import { globalClasses } from "helper/globalClasses";
import { globalVariables } from "helper/globalVariables";
import { useMediaQuery } from "react-responsive";
// Removed ListMobileTable - now always showing table view with horizontal scroll
// import { ListMobileTable } from "./Components/ListMobileTable";
import { client } from "helper/apolloConfig";
import { useLazyQuery } from "@apollo/client";
import { useContext, useEffect, useState } from "react";
import { SearchLocation } from "shared/Components/searchLocation";
import {
  TrialCalendarQuery,
  generateEntries,
} from "redux/features/trialCalendar/trialCalendarGql";
import moment from "moment";
import {
  PageContext,
  PageDispatchContext,
} from "shared/context/paginationCotnext";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import useEffectAfterMount from "helper/useEffectAfterMount";

import { MultiSelectChipsWithSearchDropdown } from "shared/Components/multiSelectWithSearchAndChips";
import {
  setHostDetails,
  setSearchDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ThreeDotMenu from "shared/Components/threeDotMenu";
import { getAllJudgeQuery } from "redux/features/hostSlice/addTrialSlice/addTrialGql";
import { CustomDateRangePicker } from "shared/Components/customDateRangePicker";
import PageInfo from "shared/Components/pageInfo";
import { Button } from "shared/Components/button";

const { paginatedDataCls } = globalClasses;

const headData = [
  {
    label: globalVariables.date,
    style: "",
  },
  {
    label: globalVariables.name,
    style: "",
  },
  //   {
  //     label: globalVariables.location,
  //     style: "pl-0 !text-left",
  //   },
  {
    label: globalVariables.city,
    style: "pl-0 !text-left",
  },
  {
    label: globalVariables.state,
    style: "pl-0 !text-left",
  },
  {
    label: globalVariables.openDate,
  },
  {
    label: globalVariables.closeDate,
  },
  {
    label: globalVariables.status,
    style: "",
  },
  {
    label: globalVariables.noOfEntries,
    style: "",
  },
  {
    label: globalVariables.trailStatus,
    style: "",
  },
  {
    label: globalVariables.action,
    style: "",
  },
];

const threeDotData = [
  globalVariables.viewEntries,
  globalVariables.downloadEntires,
  globalVariables.edit,
];

const noviceDropdownData = [
  globalVariables.sit,
  globalVariables.novice,
  globalVariables.advanced,
  globalVariables.excellent,
  globalVariables.premier,
];
// const TrailStatus = [
//   globalVariables.approve,
//   globalVariables.reject,
//   globalVariables.pending,
// ];

const TrialList = ({ setTrial, setViewEntries }) => {
  // const page = useContext(PageContext);
  // const setPage = useContext(PageDispatchContext);
  const isTabletMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  // Removed isMobile check - always show table view with horizontal scroll
  // const isMobile = useMediaQuery({ query: "(max-width: 630px)" });

  const [pageNo, setPageNo] = useState(1);

  const [dateFilter, setDateFilter] = useState("");
  const [cityFilter, setCityFilter] = useState(null);
  const [stateFilter, setStateFilter] = useState(null);
  const [levelFilter, setLevelFilter] = useState([]);
  const [judgesDropdownData, setJudgesDropdownData] = useState([]);
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const options = noviceDropdownData.map((data, index) => ({
    label: data,
    value: `option_${index}`,
  }));

  const handleFilterChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.label);
    setLevelFilter(selectedValues);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
   const onNavigate = () => {
    navigate("/host/addTrial");
  };
  const [getData, { loading, error, data }] = useLazyQuery(TrialCalendarQuery, {
    fetchPolicy: "no-cache",
  });
  const resultData = data?.getAllTrialCalendar;
  const trials = resultData?.data || [];

  const handlePaginationData = (page = 1) => {
    console.log("Handle Page Change Called ", page);
    setPageNo(page);
    // setPage(page);
  };

  useEffect(() => {
    const getJudges = async () => {
      try {
        const result = await client.query({
          query: getAllJudgeQuery,
          variables: {
            search: "",
          },
          fetchPolicy: 'network-only', // Always fetch fresh data
        });

        let data = result?.data?.getAllJudge;
        if (data) {
          // Sort judges alphabetically by name
          const sortedData = [...data].sort((a, b) => {
            const nameA = a?.name?.toLowerCase() || '';
            const nameB = b?.name?.toLowerCase() || '';
            return nameA.localeCompare(nameB);
          });
          setJudgesDropdownData(sortedData);
        }
      } catch (err) {}
    };

    getJudges();
  }, []);

  useEffect(() => {
    getData({
      variables: {
        pageNumber: pageNo,
        role: "Host",
        pageSize: 10,
        level: levelFilter.length === 0 ? null : levelFilter,
        city: cityFilter,
        state: stateFilter,
        fromDate: date.startDate
          ? moment(date.startDate).format("yyyy-MM-01")
          : null,
        toDate: date.endDate ? moment(date.endDate).format("yyyy-MM-31") : null,
      },
    });
  }, [pageNo]);

  useEffectAfterMount(() => {
    setPageNo(1);
    getData({
      variables: {
        pageNumber: 1,
        pageSize: 10,
        role: "Host",
        level: levelFilter.length == 0 ? null : levelFilter,
        city: cityFilter,
        state: stateFilter,
        fromDate: date.startDate
          ? moment(date.startDate).format("yyyy-MM-01")
          : null,
        toDate: date.endDate ? moment(date.endDate).format("yyyy-MM-31") : null,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [levelFilter, cityFilter, stateFilter, date.startDate, date.endDate]);

  const triggerDownload = (url, filename) => {
    console.log("Trigger File " , url);
    const element = document.createElement('a');
    element.href = url;
    element.setAttribute('download', "filename.csv");
  
    // Append the anchor to the body, trigger the click, then remove the anchor
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const handleDownloadIconClick = async (trial) => {
    console.log("Downloading FIle Here  mobile " , trial?.id);
    const result = await client.query({
      query: generateEntries,
      variables: {
        trialCalendarId: +trial?.id,
      },
    });
    const data = result?.data?.generateEntriesPdf;
    triggerDownload(data?.url, "dog-entries.csv");
    // window.open(data?.url, "_blank");
    return data;
  };

  const handleDownloadIconDesktop = async (id) => {
    console.log("Downloading FIle Here desktop " , id);
    const result = await client.query({
      query: generateEntries,
      variables: {
        trialCalendarId: +id,
      },
    });
    const data = result?.data?.generateEntriesPdf;
    // downloadFile(data?.url, "dog-entries.csv");
    window.open(data?.url, "_blank");
    return data;
  };

  const handleViewEntriesIconClick = (data) => {
    navigate(`/host/viewEntries/${data.id}`, { 
      state: { 
        trialDate: data.trial.trialDate, 
        trialName: data.trial.trialName 
      } 
    });
  };

  const onSelectOption = (option, data) => {
    switch (option) {
      case globalVariables.downloadEntires:
        handleDownloadIconDesktop(data?.id);
        break;
      case globalVariables.viewEntries:
        handleViewEntriesIconClick(data);
        break;
      case globalVariables.edit:
        onEdit(data);
        break;
      default:
        break;
    }
  };
  const renderTableBody = () =>
    trials.map((trial, index) => {
      
      return (
        <tr
        className={`cursor-pointer 
          ${
            trial.trial.status == "Open"
              ? "bg-lightGreen"
              :  trial.trial.status == "Close"
              ? "bg-lightRed"
              : ""
          }`}
          key={trial.id}
          onClick={() => navigate(`/host/trialDetails/${trial.id}`)}
        >
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {moment.utc(trial?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
          </td>

          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {trial?.trial?.trialName || "-"}
          </td>
          <td className={`${paginatedDataCls(index)} pl-0 !text-left`}>
            {trial?.trial?.city}
          </td>
          <td className={`${paginatedDataCls(index)} pl-0 !text-left`}>
            {trial?.trial?.state}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.openDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.closeDate).format(DEFAULT_DATE_FORMAT)}
          </td>

          <td className={paginatedDataCls(index)}>
            <span
              className={` 
                ${
                  trial.trial.status == "Open"
                    ? "text-green font-semibold"
                    :  trial.trial.status == "Close"
                    ? "text-red font-semibold"
                    : ""
                }`}
            >
              {trial?.trial?.status == "Close"
                ? "Closed"
                : trial?.trial?.status
              }
            </span>
          </td>
          <td className={paginatedDataCls(index)}>{trial?.noOfEntries}</td>
          <td className={paginatedDataCls(index)}>
            {trial?.trial?.approvalStatus == "Approve"
              ? "Approved"
              : trial?.trial?.approvalStatus
            }
          </td>
          <td className={paginatedDataCls(index)}>
            <ThreeDotMenu
              options={
                trial?.noOfEntries > 0
                  ? threeDotData
                  : [threeDotData[0], threeDotData[2]]
              }
              dynamicHeight
              onSelectOption={(option) => {
                onSelectOption(option, trial);
              }}
            />
          </td>
        </tr>
      );
    });

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid #ccc",
      width: "220px",
      borderRadius: "6px",
      backgroundColor: "#ffffff80",
      minHeight: "44px",
      boxShadow: state.isFocused ? "0 0 0 1px #007bff" : null,
      "&:hover": {
        borderColor: "#007bff",
      },
    }),
  };

  const onEdit = (data) => {
    const {
      trialName,
      trialLocationName,
      trialLocationAddress,
      city: trialCity,
      state: trialState,
      zip: trialZip,
      description,
      notes,
      timezone,
      noOfJudge,
      trialDate,
      closeDate,
      openDate,
      cutoffDate,
      trialImages,
      trialFile,
      judgeAuthId,
      maxEntries,
    } = data?.trial || {};
    const {
      hostName,
      contactAddress,
      city,
      state,
      trialSecretaryEmail,
      trialSecretaryName,
      zip,
      paypalEmail,
      paypalPaymentLink,
    } = data?.host || {};
    const trialImagesName = trialImages?.split("/");
    const trialFileName = trialFile?.split("/");
    const searchRes = data?.search;
    const searchData = searchRes?.map((e) => ({
      title: e?.element,
      levelNovice: e?.level,
      elements: e?.element,
      searchName: e?.searchName,
      entryFee: e?.entryFee,
    }));
    const judgeData = [];
    judgeAuthId?.map((e) => {
      const detail = judgesDropdownData.filter((ele) => ele?.authId === e)?.[0];

      judgeData.push({
        value: detail?.name,
        label: detail?.name,
        authId: detail?.authId,
      });
    });

    dispatch(
      setHostDetails({
        hostName,
        contactAddress,
        hostPaypalEmail: paypalEmail,
        paypalPaymentLink: paypalPaymentLink,
        trialSecretaryName,
        trialSecretaryEmailAddress: trialSecretaryEmail,
        zip,
        city,
        state,
      })
    );
    dispatch(
      setTrialDetails({
        trialName,
        trialLocationName,
        trialLocationAddress,
        city: trialCity,
        state: trialState,
        zip: trialZip,
        description,
        notes,
        maxEntries,
        numberOfJudges: noOfJudge,
        timeZone: timezone,
        trialDate,
        openDate,
        closeDate,
        cutoffDate,
        image: trialFile,
        fileName: trialFileName[trialFileName?.length - 1],
        fileSize: "100KB",
        addedJudges: judgeData,
      })
    );
    dispatch(setSearchDetails(searchData));
    navigate("/host/trialCalendarEditTrial", { state: { id: data?.id } });
  };

  const onClearFilters = () => {
    setCityFilter(null);
    setStateFilter(null);
    setLevelFilter([]);
    setDate(() => ({
      startDate: null,
      endDate: null,
    }))
  };

  return (
    <>
      <PageInfo  title={globalVariables.myTrial}>
        <div className="flex gap-2">
          <Button 
            onClick={onNavigate}
            width="w-auto"
            label={globalVariables.addTrial}
            icon={plus}
          />
          <Button
            width={"w-auto"}
            label="Clear All Filters"
            onClick={onClearFilters} 
          />
        </div>
      </PageInfo>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 my-5">
        <CustomDateRangePicker
          defaultStartDate={date.startDate}
          defaultEndDate={date.endDate}
          isShadow={true}
          width={"w-full"}
          onSetDate={(startDate, endDate) => {
            setDate({
              ...date,
              startDate: startDate ? new Date(startDate) : null,
              endDate: endDate ? new Date(endDate) : null,
            });
          }}
        />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="State"
          types={["(regions)"]}
          placeholder={globalVariables.state}
          onSelectLocation={(location) => {
            setStateFilter(location);
          }}
          defaultValue={stateFilter}
        />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="city"
          placeholder={globalVariables.city}
          types={["(cities)"]}
          onSelectLocation={(location) => {
            setCityFilter(location);
          }}
          defaultValue={cityFilter}
          searchBy={stateFilter}
        />
        <MultiSelectChipsWithSearchDropdown
          defaultSelectedOptions={levelFilter}
          width={"w-full"}
          placeholder={globalVariables.level}
          options={options}
          label=""
          onChange={handleFilterChange}
        />
      </div>
      {/* Always show table view with horizontal scroll on mobile */}
      <div className="overflow-x-auto">
        <TableWithPagination
          headData={headData}
          headDateWithStyle={true}
          tableHeight={`${isTabletMobile ? "h-[85vh]" : "h-[600px]"}`}
          tableBody={renderTableBody()}
          itemsPerPage={10}
          totalPage={resultData?.totalPages}
          handlePageChange={(page) => handlePaginationData(page)}
          loading={loading}
          current={pageNo}
          error={error}
          persistPagination={true}
        />
      </div>
    </>
  );
};

export default TrialList;
